module.exports = __webpack_public_path__ + "img/outfits.55c8b269.svg";